module.exports = __webpack_public_path__ + "img/20200113160206064.1a99a4e6.jpg";